import { Component, OnInit, OnDestroy, Input, Output, EventEmitter } from '@angular/core';
import { FormArray, FormBuilder, FormControl, FormGroup, Validators} from '@angular/forms';
import { MaterializeAction, MaterializeDirective } from 'angular2-materialize';
import { ActivatedRoute } from '@angular/router';
import { Utils } from '../../util';

import { RemissionService, ProductionOrder, Box } from '../../services/remission.service';
import { CustomerSupplierService } from '../../services/customer-supplier.service';
import { FiscalDataService } from '../../services/fiscal-data.service';
import { AddressService } from '../../services/address.service';
import { ProductionOrderService, ProductionOrderData } from '../../services/production-order.service';

import { ISubscription, Subscription } from "rxjs/Subscription";
import { AuthService } from '../../services/auth.service';
import { AutoService, FsAuto } from '../../services/auto.service';
import { EmployeeId, EmployeeService } from '../../services/employee.service';

@Component({
  selector: 'app-update-remission',
  templateUrl: './update-remission.component.html',
  styleUrls: ['./update-remission.component.css']
})
export class UpdateRemissionComponent implements OnInit, OnDestroy {
  userHistory: any[] =[];

  remissionId: string;
  customerId: string;
  customerName: string = '';

  form: FormGroup;

  fiscalDatas = {};
  selectedFiscalDataId: string;

  addresss = {};
  selectedAddressId: string;

  autos: {[id: string]: FsAuto} = {};
  selectedAutoId: string = '';

  employees: {[id: string]: EmployeeId} = {};
  selectedDriverEmployeeId: string = '';

  productionOrders = {};
  remittedQuantity: number = 0;
  productionOrder: ProductionOrder = {
    id: '',
    folio: '-',
    quantity: 0,
    prClientCode: '-',
    prClientVersion: '-',
    prClientBarCode: '-',
    customerPurchaseOrderNumber: '-'
  };

  modalActionsRead = new EventEmitter<string|MaterializeAction>();
  modalParamsRead = [{dismissible: true}];
  
  pickadateParams = Utils.pickadateParams();

  subs = [];

  remInputObj = {
    distanceTraveledKm: {key: 'distanceTraveledKm', label: 'Distancia Recorrida Km', type: 'number', value: 0},
    dateArrival: {key: 'dateArrival', label: 'Fecha llegada', type: 'date', value: Utils.today},
    timeArrival: {key: 'timeArrival', label: 'Hora llegada', type: 'time', value: `01:00PM`},
    weightBoxesKg: {key: 'weightBoxesKg', label: 'Peso Cajas Kg', type: 'number', value: 0},
    license: {key: 'license', label: 'Licencia', type: 'text', value: ''},
    permitSCT: {key: 'permitSCT', label: 'Permiso SCT', type: 'text', value: ''},
  };
  get remInputs(){ return Object.values(this.remInputObj); }

  constructor(
    private service: RemissionService,
    private customerService: CustomerSupplierService,
    private fiscalDataService: FiscalDataService,
    private addressService: AddressService,
    private productionOrderService: ProductionOrderService,
    private authService: AuthService,
    private autoService: AutoService,
    private employeeService: EmployeeService,
    private activatedRoute: ActivatedRoute,
    private fb: FormBuilder
  ) {
    this.remissionId = this.activatedRoute.snapshot.paramMap.get('id');
    this.customerId = this.activatedRoute.snapshot.paramMap.get('customerId');
    this.subs.push( this.customerService.getCustomerSupplier(this.customerId).subscribe(c => { this.customerName = c.name }) );

    this.subs.push(
      this.fiscalDataService.getCustomerFiscalDatas(this.customerId).subscribe(fiscalDatas => {
        this.fiscalDatas = {};
        this.rowsRead[0] = fiscalDatas.filter(fiscalData => {
          fiscalData.name = fiscalData.businessName;
          this.fiscalDatas[fiscalData.id] = {...fiscalData};
          return fiscalData;
        });
      })
    );
    this.subs.push(
      this.addressService.getCustomerAddresses(this.customerId).subscribe(addresss => {
        this.addresss = {};
        this.rowsRead[1] = addresss.filter(address => {
          address.name = `${address.street}, #${address.externalNumber}`;
          this.addresss[address.id] = {...address};
          return address;
        });
      })
    );
    this.subs.push(
      this.productionOrderService.getProductionOrders().subscribe(productionOrders => {
        this.productionOrders = {};
        this.rowsRead[2] = productionOrders.filter(productionOrder => {
          this.productionOrders[productionOrder.id$] = {...productionOrder};
          if(productionOrder.customer.id == this.customerId) return productionOrder;
        })
      })
    );
    this.subs.push(
      this.employeeService.getEmployees().subscribe(employees => {
        this.employees = employees.reduce((acc, cur) => ({...acc, [cur.id]: {...cur}}), {});
        this.rowsRead[4] = Object.values(employees);
      })
    );
  }

  ngOnInit() {
    this.createForm();
    let subRem = this.service.getRemission(this.remissionId).subscribe(([remission]) => {
      subRem.unsubscribe();

      let { userHistory=[{name:'Desconocido',date:'Desconocida'}], fiscalDataObj: {id: fiscalDataId}, addressObj: {id: addressId}, productionOrder, boxs, ...formRemission } = remission;
      this.userHistory = userHistory;
      this.form.patchValue(formRemission);
      this.selectedFiscalDataId = fiscalDataId;
      this.selectedAddressId = addressId;
      this.productionOrder = productionOrder;
      let sub =  this.productionOrderService.getProductionOrder(productionOrder.id).subscribe(([productionOrder]) => {
        this.remittedQuantity = productionOrder.remittedQuantity - formRemission.quantity;
        sub.unsubscribe();
      });
      this.boxs = boxs;
      this.selectedAutoId = formRemission.autoId;
      this.selectedDriverEmployeeId = formRemission.driverEmployeeId;
      for(let key in this.remInputObj) this.remInputObj[key].value = remission[key];
    });
    this.onInit();
  }
	ngOnDestroy() {
    this.subs.map((sub, index) => {
      this.subs[index].unsubscribe();
    });
  }
  async onInit(){
    let autos: FsAuto[] = await this.autoService.getAutos();
    this.autos = autos.reduce((acc, cur) => ({...acc, [cur.id]: {...cur}}), {});
    this.rowsRead[3] = Object.values(this.autos).map(auto => {
      return {name: auto.placa, ...auto};
    });
  }

  createForm(){
    this.form = this.fb.group({
      folio: ['', Validators.required],
      date: [this.today, Validators.required],
      quantity: ['', [Validators.required, Validators.min(0)]],
      description: ['', Validators.required],
      notesEtiq: ''
    });
  }

  onSubmit({ value, valid }: { value: any, valid: any }){
    let {id, fullName: name} = this.authService.currentUser;
    value.userHistory = [...this.userHistory, {id, name, date: this.today}];

    value.customerRef = this.customerId;
    value.fiscalDataRef = this.selectedFiscalDataId;
    value.addressRef = this.selectedAddressId;
    value.productionOrder = this.productionOrder;
    value.boxs = this.boxs;
    value.status = 0;

    value.autoId = this.selectedAutoId;
    value.driverEmployeeId = this.selectedDriverEmployeeId;
    for(let remInput of this.remInputs) value[remInput.key] = remInput.type == 'number' ? +remInput.value : remInput.value;

    this.service.updateRemission(this.remissionId, value).then(() => {
      let remittedQuantity = this.remittedQuantity + value.quantity;
      this.productionOrderService.putProductionOrder({remittedQuantity}, this.productionOrder.id);
      this.service.windowReplace('view', this.remissionId);
    });
  }

  openModalRead(index: number) {
    this.currentReadIndex = index;
    this.data = this.rowsRead[index];
    
    this.config = this.configs[index];
  
    this.onChangeTable(this.config);
    this.modalActionsRead.emit({ action: 'modal', params: ['open'] });
  }
  closeModalRead() {
    this.modalActionsRead.emit({ action: 'modal', params: ['close'] });
  }
  selectRead({row}): any{
    if(this.currentReadIndex == 0) this.selectedFiscalDataId = row.id;
    if(this.currentReadIndex == 1) this.selectedAddressId = row.id;
    if(this.currentReadIndex == 2) {
      let {
        id$: id,
        name: folio,
        quantity = 0,
        prClient: { code: prClientCode = '-', version: prClientVersion = '-', barCode: prClientBarCode = '-' },
        customer: { purchaseOrderNumber: customerPurchaseOrderNumber = '-' },
        longDescription
      } = this.productionOrders[row.id$];
      this.productionOrder = { id, folio, quantity, prClientCode, prClientVersion, prClientBarCode, customerPurchaseOrderNumber }
      this.form.get('description').patchValue(longDescription);
    }
    if(this.currentReadIndex == 3) this.selectedAutoId = row.id;
    if(this.currentReadIndex == 4) this.selectedDriverEmployeeId = row.id;
    this.closeModalRead();
  }

  get today(){
    var today = new Date();
    var dd:string = today.getDate() + '';
    var mm:string = today.getMonth()+ 1 + '';
    var yyyy = today.getFullYear();
    if(+dd<10) dd = '0'+dd;
    if(+mm<10) mm = '0'+mm;
    return yyyy + '-' + mm + '-' + dd;
  }

  //////////////////////////////////////////////////////////////////////////////////////////////BOXS
  box: Box = {} as Box;
  boxs: Box[] = [];
  modalActionsBox = new EventEmitter<string|MaterializeAction>();
  modalParamsBox = [{dismissible: true}];
  get boxIsValid(){
    const {amount, pieces} = this.box;
    //list of validators
    return !(
      !amount ||
      amount <= 0 ||
      !pieces ||
      pieces <= 0 
    )
  }
  get boxsTotal(): number {
    return this.boxs.reduce((total, {amount, pieces}) => total + amount*pieces, 0);
  }
  get boxsTotalIsValid(){
    return this.boxsTotal == this.form.get('quantity').value;
  }
  
  currentEditingIndexBox: number;
  openModalBox(index?: number) {
    this.currentEditingIndexBox = index;
    this.box = index != undefined ? {...this.boxs[this.currentEditingIndexBox]} : {} as Box;
    this.modalActionsBox.emit({ action: 'modal', params: ['open'] });
  }
  closeModalBox() {
    this.modalActionsBox.emit({ action: 'modal', params: ['close'] });
  }
  
  touchBox(){
    if(this.currentEditingIndexBox == undefined) this.boxs.push({...this.box});
    else this.boxs[this.currentEditingIndexBox] = {...this.box};
    this.closeModalBox();
  }
  removeBox(index) {
    this.boxs.splice(index,1);
  }
  //////////////////////////////////////////////////////////////////////////////////////////////BOXS

  //////////////////////////////////////////////////////////////////////////////////////////////READ MODAL DATA 
  get readValid(){ return this.selectedFiscalDataId && this.selectedAddressId && this.productionOrder };
  currentReadIndex: number;
  rowsRead = [[], [], [], [], []];
  columnsRead = [
    [
      { title: 'Razón Social', name: 'name', sort: 'asc' },
      { title: 'RFC', name: 'rfc' }
    ],
    [
      { title: 'Dirección', name: 'name', sort: 'asc' },
      { title: 'C.P.', name: 'zipCode' },
      { title: 'Municipio', name: 'municipality' }
    ],
    [
      { title: 'Folio', name: 'name', sort: 'desc' },
      { title: 'Compromiso de entrega', name: 'deliveryDate' },
      { title: 'Cantidad', name: 'quantity' },
      { title: 'Estatus', name: 'status' }
    ],
    [
      { title: 'Placa', name: 'name', sort: 'asc' },
      { title: 'Modelo', name: 'model' },
      { title: 'Año', name: 'year' },
      { title: 'Color', name: 'color' },
    ],
    [
      { title: 'Nombre', name: 'name' },
      { title: 'Appellidos', name: 'lastName', sort: 'asc' },
      { title: 'Email', name: 'email' },
      { title: 'Folio', name: 'internalKey' },
    ],
  ]


  data:Array<any>;
  rows:Array<any> = [];
  page:number = 1;
  itemsPerPage:number = 5;
  maxSize:number = 5;
  numPages:number = 1;
  length:number = 0;

  config;
  configs:any = this.columnsRead.map(columns => ({
    paging: true,
    sorting: {columns: columns},
    filtering: {filterString: ''}
  }));

  /*********** Filter, sort, and pagination */

	changePage(page:any, data:Array<any> = this.data):Array<any> {
    let start = (page.page - 1) * page.itemsPerPage;
    let end = page.itemsPerPage > -1 ? (start + page.itemsPerPage) : data.length;
    return data.slice(start, end);
  }

  changeSort(data:any, config:any):any {
    if (!config.sorting) {
      return data;
    }

    let columns = this.config.sorting.columns || [];
    let columnName:string;
    let sort:string;

    for (let i = 0; i < columns.length; i++) {
      if (columns[i].sort !== undefined && columns[i].sort !== '' && columns[i].sort !== false) {
        columnName = columns[i].name;
        sort = columns[i].sort;
      }
    }

    if (!columnName) {
      return data;
    }

    // simple sorting
    return data.sort((previous:any, current:any) => {
      if (previous[columnName] > current[columnName]) {
        return sort === 'desc' ? -1 : 1;
      } else if (previous[columnName] < current[columnName]) {
        return sort === 'asc' ? -1 : 1;
      }
      return 0;
    });
  }

  changeFilter(data:any, config:any):any {
    let filteredData:Array<any> = data;
    this.columnsRead[this.currentReadIndex].forEach((column:any) => {
      if (column.filtering) {
        filteredData = filteredData.filter((item:any) => {
          return item[column.name].match(column.filtering.filterString);
        });
      }
    });

    if (!config.filtering) {
      return filteredData;
    }

    if (config.filtering.columnName) {
      return filteredData.filter((item:any) => item[config.filtering.columnName].match(this.config.filtering.filterString));
    }

    let tempArray:Array<any> = [];
    filteredData.forEach((item:any) => {
      let flag = false;
      this.columnsRead[this.currentReadIndex].forEach((column:any) => {
        if (item[column.name] && item[column.name].toString().toLowerCase().match(this.config.filtering.filterString.toLowerCase())) {
          flag = true;
        }
      });
      if (flag) {
        tempArray.push(item);
      }
    });
    filteredData = tempArray;

    return filteredData;
  }

  onChangeTable(config:any, page:any = {page: this.page, itemsPerPage: this.itemsPerPage}):any {
    if (config.filtering) {
      Object.assign(this.config.filtering, config.filtering);
    }

    if (config.sorting) {
      Object.assign(this.config.sorting, config.sorting);
    }

    let filteredData = this.changeFilter(this.data, this.config);
    let sortedData = this.changeSort(filteredData, this.config);
    this.rows = page && config.paging ? this.changePage(page, sortedData) : sortedData;
    this.length = sortedData.length;
  }

  //////////////////////////////////////////////////////////////////////////////////////////////READ MODAL DATA

}
